import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { selectWorks } from '../../Api/selectors';
import { fetchUsers, changeUserFilter, changeWebsiteUserFilter } from '../actions';
import { REQUEST_USERS } from '../constants';
import {
  selectUserCount,
  selectUserPaginator,
  selectUsers,
  selectWebsiteUser,
  selectWebsiteUserFilter,
  selectWebsiteUserPaginator,
  selectWebsiteUsers,
} from '../selectors';
import { Content } from '../../../components/Content';
import { HBox, VBox } from '../../../components/Box';
import { Check, ChevronRight, Right } from '../../../components/Icon';
import { UserSearch } from '../components/Search';
import { PageHeader } from '../../../components/PageHeader';
import { COLOR_TABLE_HEADER } from '../../../vars';
import { Checkbox } from '../../../components/Checkbox';
import { Sort } from '../../../components/Sort';
import { KanbanProgressBar } from '../../KanbanBoards/components/ProgressBar';
import { VehicleAvatar } from '../../../components/VehicleAvatar';
import { formatCurrency, formatLicensePlate } from '../../../utils/string';
import { Button } from '../../../components/Buttons';
import { UserModal } from '../components/AddUserModal';
import { Pagination } from '../../../components/Pagination';
import { setScrollPosition } from '../../Actions/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import cn from 'classnames';
import s from './overview.module.css';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import CardComponent from '../../../containers/App/Components/Card/Card';
import { WebsiteUsersMainFilterSection } from './website/websiteUsersMainFilterSection';

export const IconContainer = styled.div`
  width: 18px;
  height: 18px;
  font-size: 18px;
  color: #0bcf97;
  background-color: white;
  border: 1px solid #b7babc;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 6px;
  cursor: pointer;
`;

const STATE = {
  isOpen: false,
  currentPage: 0,
};

/* eslint-disable react/prefer-stateless-function */
class UsersOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  onSelectMainFilter(filterName) {
    if (filterName === this.selectedWebsiteFilter) {
      this.props.changeWebsiteFilter('mainFilter', null);
      return;
    }
    this.props.changeWebsiteFilter('mainFilter', filterName);
  }

  get users() {
    if (this.selectedWebsiteFilter) {
      return this.props.websiteUsers;
    }

    return this.props.users;
  }

  get selectedWebsiteFilter() {
    return this.props?.websiteFilter?.mainFilter ?? null;
  }

  cols() {
    return [
      'name',
      'surname',
      'email_address',
      'weblogin',
      'approved_for_website',
      'evaluate_for_website',
      'financial_price_b2c',
      'financial_price_b2b_incl_vat_btpm',
      'financial_price_gross_incl_btw_bpm',
      'financial_price_nett_excl_vat_bpm',
      'id',
    ];
  }

  selectPage = newPage => {
    const paginator = this.selectedWebsiteFilter ? this.props.websitePaginator : this.props.paginator;
    const newOffset = newPage * paginator?.limit ?? 0;
    this.props.setScrollPosition(null);
    this.setState({ currentPage: newPage }, this.props.changeFilter(newOffset, this.selectedWebsiteFilter));
  };

  handleClick = (event, itemId) => {
    this.props.setScrollPosition(`#item${itemId}`);
    this.to(`/users/${itemId}`, event?.ctrlKey || event?.metaKey);
  };
  renderRow(user) {
    return (
      <tr
        className={`align-middle ${s.thead}`}
        key={user.id}
        id={`item${user.id}`}
        onClick={event => this.handleClick(event, user.id)}
      >
        <td className={s.bodyTd}>
          <div className={s.checkboxContainerTd}>
            <CheckboxComponent />
          </div>
        </td>
        {this.cols().map(col => (
          <td className={s.bodyTd}>{this.renderCell(col, user)}</td>
        ))}
      </tr>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      default:
        return this.lbl(`users.overview.column.${col}`);
    }
  }

  renderCell(col, user) {
    const fn = () => {
      switch (col) {
        case 'name':
          return (
            <>
              {user.name}&nbsp;{user.surname}
              <br />
            </>
          );
        case 'weblogin':
        case 'approved_for_website':
        case 'evaluate_for_website':
        case 'financial_price_b2c':
        case 'financial_price_b2b_incl_vat_btpm':
        case 'financial_price_gross_incl_btw_bpm':
        case 'financial_price_nett_excl_vat_bpm':
          return user?.[col] === '1' ? (
            <IconContainer>
              <FontAwesomeIcon icon={faCheckSquare} />
            </IconContainer>
          ) : null;
        default:
          return user[col];
      }
    };

    return (
      <div className={`item-cell col-${col}`} key={`${col}-${user.id}`}>
        {fn()}
      </div>
    );
  }

  renderCard = (user, idx) => {
    return (
      <CardComponent
        userPage
        key={user.id ?? `user${idx}`}
        id={`item${user.id}`}
        onClick={() => this.handleClick(user.id)}
        title={
          <div className={s.cardTitle}>
            <CheckboxComponent className={s.checkbox} />
            <div className={s.containerInfo}>
              <span className={s.cardInfoCar}>{user?.id}</span>
            </div>
          </div>
        }
      >
        <div className={cn('text-muted', s.gridCard)}>
          <div className={s.gridCardColumn}>
            <h6>
              <strong>{user?.name ?? 'Unknown Name'}</strong> {user?.surname ?? 'Unknown Surname'}
            </h6>
            <h6 className={s.gridCardItem}>{user?.email_address}</h6>
            <div className={s.gridCardItem}>
              <KanbanProgressBar type="user" target={user} />
            </div>
          </div>
        </div>
      </CardComponent>
    );
  };

  renderCreateUserModal() {
    return (
      <>
        <UserModal toggle={() => this.setState({ isOpen: false })} />
      </>
    );
  }

  renderPagination(websiteUserFilter) {
    const paginator = websiteUserFilter ? this.props.websitePaginator : this.props.paginator;

    return (
      !!this.props.users?.length &&
      paginator?.itemsCount > paginator?.limit && <Pagination paginator={paginator} selectPage={this.selectPage} />
    );
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <div className={cn('container-fluid p-0', s.container)}>
        <PageHeader
          title={
            <>
              {this.lbl('users.overview.title')} <span className="label number">{this.props.count}</span>
            </>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('users.overview.title')}
            </>
          }
        />

        <div className="container-fluid p-0">
          <HBox right>
            <Button primary small onClick={() => this.setState({ isOpen: true })}>
              Create user+
            </Button>
          </HBox>

          <UserSearch />
        </div>

        {window.innerWidth <= 768 ? (
          <>
            {this.props?.users
              ?.filter(v => v)
              .map((user, idx) => (
                <div className="rows">{this.renderCard(user, idx)}</div>
              ))}
          </>
        ) : (
          <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
            <thead className="align-middle">
              <tr className={cn('align-middle', s.thead)}>
                <th className={s.headTh}>
                  <CheckboxComponent />
                </th>
                {this.cols().map((col, index) => (
                  <th className={s.headTh} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                    <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                      {this.renderHeaderCell(col)}

                      <Sort direction={this.state.sort == col ? this.state.sort_direction : 'none'} />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{this.users.filter(v => v).map(user => this.renderRow(user))}</tbody>
            {/* <div className="header">
              <HBox vCenter left>
                <div className="check-col">
                  <Checkbox />
                </div>
                {this.cols().map((col, index) => (
                  <HBox
                    className={`header-col col-${col}`}
                    vCenter
                    left
                    key={`${col}-${index}`}
                    onClick={() => this.sortOn(col)}
                  >
                    {this.renderHeaderCell(col)}
                    <Sort direction={this.state.sort == col ? this.state.sort_direction : 'none'} />
                  </HBox>
                ))}
              </HBox>
            </div> */}
            {/* {this.props.users.filter(v => v).map(user => this.renderRow(user))} */}
          </table>
        )}

        {this.renderPagination(this.selectedWebsiteFilter)}

        {this.state.isOpen && this.renderCreateUserModal()}
      </div>
    );
  }
}

UsersOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    websiteUsers: selectWebsiteUsers(),
    users: selectUsers(),
    count: selectUserCount(),
    paginator: selectUserPaginator(),
    websitePaginator: selectWebsiteUserPaginator(),
    work: selectWorks([REQUEST_USERS]),
    websiteFilter: selectWebsiteUserFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchUsers());
    },
    changeFilter(offset, isWebsite) {
      isWebsite ? dispatch(changeWebsiteUserFilter('offset', offset)) : dispatch(changeUserFilter('offset', offset));
    },
    changeWebsiteFilter(key, value) {
      dispatch(changeWebsiteUserFilter(key, value));
    },
    setScrollPosition(elemId) {
      dispatch(setScrollPosition(elemId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UsersOverview = compose(withConnect, withRouter)(UsersOverviewComp);
